import React, { useState } from "react";
import { EditableInputDisplay } from "../../EditableComponents";
import {
  Button,
  Container,
  DialogActions,
  Paper,
  TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useChangePassword } from "..";
import * as yup from "yup";

const validationSchema = yup.object({
  currentPassword: yup
    .string("Password Attuale")
    .required("Il campo non puo essere vuoto"),
  newPassword: yup
    .string("Nuova password")
    .required("Il campo non puo essere vuoto"),
  confirmNewPassword: yup
    .string("Conferma nuova password")
    .oneOf([yup.ref("newPassword"), null], "Passwords must match")
    .required("Il campo non puo essere vuoto"),
});

function ChangePassword() {
  const changePasswordMutation = useChangePassword();

  // === Form handling ===
  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      if (
        values.currentPassword.length > 0 &&
        values.newPassword.length > 0 &&
        values.newPassword === values.confirmNewPassword
      ) {
        changePasswordMutation.mutate({
          current_password: values.currentPassword,
          new_password: values.newPassword,
        });
        formik.handleReset();
      }
    },
  });

  return (
    <Paper
      style={{
        height: "fitContent",
        width: "30%",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <h2 style={{ textAlign: "center", padding: 5 }}>Cambio password</h2>
      <Container>
        <form onSubmit={formik.handleSubmit}>
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            id="currentPassword"
            name="currentPassword"
            label="Password attuale"
            type="password"
            variant="standard"
            onChange={formik.handleChange}
            value={formik.values.currentPassword}
            error={
              formik.touched.currentPassword &&
              Boolean(formik.errors.currentPassword)
            }
            helperText={
              formik.touched.currentPassword && formik.errors.currentPassword
            }
          />

          <TextField
            margin="dense"
            fullWidth
            id="newPassword"
            name="newPassword"
            label="Nuova password"
            type="password"
            variant="standard"
            onChange={formik.handleChange}
            value={formik.values.newPassword}
            error={
              formik.touched.newPassword && Boolean(formik.errors.newPassword)
            }
            helperText={formik.touched.newPassword && formik.errors.newPassword}
          />

          <TextField
            margin="dense"
            fullWidth
            id="confirmNewPassword"
            name="confirmNewPassword"
            label="Conferma nuova password"
            type="password"
            variant="standard"
            onChange={formik.handleChange}
            value={formik.values.confirmNewPassword}
            error={
              formik.touched.confirmNewPassword &&
              Boolean(formik.errors.confirmNewPassword)
            }
            helperText={
              formik.touched.confirmNewPassword &&
              formik.errors.confirmNewPassword
            }
          />

          <Container sx={{ padding: "1vmin" }}>
            <DialogActions>
              <Button type="submit">Conferma</Button>
              <Button onClick={formik.handleReset}>Reset</Button>
            </DialogActions>
          </Container>
        </form>
      </Container>
    </Paper>
  );
}

export default ChangePassword;
